export default __webpack_public_path__ + "static/media/bannerFoxtonMobile.facd7f86.svg";